export class SelectedScenarios {
  constructor(public readonly cbId: number, public readonly scenarioIds: number[]) {}
}
